/*
 * Import Global Modules
 */
import '@/bootstrap';
import VueBootstrapper from '@/VueBootstrap';

/*
 * Main web Application
 */
import App from './VueApplication/App';

/*
 * Init bootLoader
 */
const vueWebBootLoader = new VueBootstrapper();

/*
 * Start Application
 */
vueWebBootLoader.init(App).mount('#app');



// WEBPACK FOOTER //
// ./templates/floor/assets/js/app.js